export default "__VITE_ASSET__CjjpArz4__"